import type { FunctionalComponent } from 'preact';
import { useStore } from '../store';
import { useCountdown } from '../hooks/useCountdown';
import { formatDate } from '../utils/theme';
import { getWidgetEventOpenUrl } from '../lib/eventShareUrl';
import { resolveDisplayOccurrenceIso } from '../lib/eventOccurrenceDates';
import { EventHeroQr } from './EventHeroQr';

export const EventHeader: FunctionalComponent = () => {
  const { state } = useStore();
  const { event, widget } = state;
  if (!event || !widget) return null;

  const startForDisplay = resolveDisplayOccurrenceIso(event, state.selectedOccurrenceIso);
  const countdown = useCountdown(startForDisplay);

  const isCompact = widget.layout === 'compact';
  const showImage = widget.show_event_image && event.feature_image && !isCompact;

  const shareUrl = getWidgetEventOpenUrl(event, state.refCode);

  return (
    <div class="mw-event-hero">
      {showImage && (
        <div class="mw-event-hero-image-wrap">
          <img class="mw-event-image" src={event.feature_image} alt={event.name} loading="lazy" />
          <EventHeroQr shareUrl={shareUrl} eventName={event.name} />
        </div>
      )}
      <div class="mw-event-header">
        <div class="mw-event-name">{event.name}</div>
        {widget.show_event_description && event.description && (
          <div class="mw-tier-desc">{event.description}</div>
        )}
        <div class="mw-event-meta">
          <span>{formatDate(startForDisplay, event.timezone)}</span>
          {event.location && <span>{event.location.address}</span>}
          {event.kind && (
            <span class="mw-event-kind-chip">{event.kind.replace(/_/g, ' ')}</span>
          )}
        </div>
        {widget.show_countdown && !countdown.isExpired && (
          <div class="mw-countdown">
            <span>⏱</span>
            <span>Starts in {countdown.label}</span>
          </div>
        )}
      </div>
    </div>
  );
};
